import React, { useState } from "react";
import { GREY_GRADIENT_PANEL_BACKGROUND } from "../../../../constants/styles";

export default function BuildingNavigator() {

  var [mode, setMode] = useState("origin"); // origin | destination
  var [selectedBuilding, setSelectedBuilding] = useState("Building A");

  return (
    <div
      style={{
        width: "100%",
        background: "#FAFBFC",
        borderRight: "1px solid #e6e6e6",
        height: "calc(100vh - 100px)"
      }}
    >

      {/* HEADER */}
      <div
        style={{
          background: GREY_GRADIENT_PANEL_BACKGROUND,
          padding: "14px",
          paddingBottom: "15px"
        }}
      >

        {/* MODE TOGGLE – SEGMENTED CONTROL STYLE */}
        <div
          style={{
            display: "flex",
            background: "#f1f3f5",
            borderRadius: "10px",
            padding: "4px"
          }}
        >
          {["origin", "destination"].map(function (m) {
            var active = mode === m;

            return (
              <div
                key={m}
                onClick={function () {
                  setMode(m);
                }}
                style={{
                  flex: 1,
                  textAlign: "center",
                  padding: "8px 0",
                  borderRadius: "8px",
                  fontSize: "13px",
                  cursor: "pointer",
                  background: active ? "linear-gradient(180deg, #ffffff, #f6f8fb)" : "transparent",
                  color: active ? "#2563eb" : "#666",
                  fontWeight: 600,
                  boxShadow: active ? "0 2px 6px rgba(0,0,0,0.08)" : "none",
                  transition: "all 0.15s ease"
                }}
              >
                {m === "origin" ? "Origin" : "Destination"}
              </div>
            );
          })}
        </div>
      </div>

      {/* BODY */}
      <div style={{ padding: "16px" }}>

        {/* TITLE */}
        <div
          style={{
            fontSize: "12px",
            fontWeight: 600,
            color: "#888",
            marginBottom: "10px",
            letterSpacing: "0.5px"
          }}
        >
          BUILDINGS
        </div>

        {/* BUILDINGS */}
        {["Building A", "Building B", "Building C"].map(function (building) {
          var isSelected = selectedBuilding === building;

          return (
            <div
              key={building}
              onClick={function () {
                setSelectedBuilding(building);
              }}
              style={{
                background: "#ffffff",
                borderRadius: "10px",
                padding: "14px",
                marginBottom: "12px",
                border: isSelected
                  ? "1px solid #2563eb"
                  : "1px solid #e5e7eb",
                boxShadow: isSelected
                  ? "0 4px 12px rgba(0,0,0,0.08)"
                  : "0 1px 3px rgba(0,0,0,0.05)",
                cursor: "pointer",
                transition: "all 0.15s ease"
              }}
            >
              <div style={{ fontWeight: 600 }}>{building}</div>

              <div
                style={{
                  fontSize: "12px",
                  color: "#777",
                  marginBottom: "8px"
                }}
              >
                {mode === "origin"
                  ? "Origin building"
                  : "Destination building"}
              </div>

              {["Zone 1", "Zone 2"].map(function (zone, index) {
                return (
                  <div
                    key={zone}
                    style={{
                      background: index % 2 === 0 ? "#f9fafb" : "#f3f4f6",
                      borderRadius: "6px",
                      padding: "8px 10px",
                      marginTop: "6px",
                      fontSize: "13px",
                      display: "flex",
                      justifyContent: "space-between"
                    }}
                  >
                    <span>{zone}</span>
                    <span style={{ color: "#999" }}>12 desks</span>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>

    </div>
  );
}
